<template>
  <button class="flex flex-row items-center border-r border-r-primary pt-2">
    <div class="relative">
      <UserIcon
        class="rounded-full border mr-1"
        :class="isActive ? 'bg-primary text-white border-white' : 'bg-white text-primary border-primary'"
        :size="5"
      />
      <div
        v-if="beneficiary.programs.length > 0"
        class="dot"
      />
    </div>
    <div class="text-md whitespace-nowrap">
      {{ beneficiary.information?.name }}
    </div>
    <Dot />
  </button>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {Dot} from "@lucide/vue";
import UserIcon from '@/core/components/icons/User.vue';

export default defineComponent({
    name: 'CustomerHeaderBeneficiary',
    components: {UserIcon, Dot},
    props: {
        beneficiary: {
            type: Object,
            required: true
        }
    },
    computed: {
        isActive() {
            return this.$route.name === 'customer.beneficiary'
                || this.$route.name === 'customer.pet'
                || this.$route.name == 'customer.pet.create';
        }
    }
});
</script>

<style scoped>
.dot {
    @apply rounded-full bg-orange w-3 absolute h-3;
    top: -4px;
    right: 3px;
}
</style>
